const vehicles = [
  {
    name: "L200",
    years: "Todas las versiones",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20L200%20pickup%20truck%20white%20clean%20background%20professional%20automotive%20photography%20side%20view&width=320&height=200&seq=veh001&orientation=landscape",
  },
  {
    name: "Montero / Pajero",
    years: "Todas las versiones",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20Montero%20Pajero%20SUV%20white%20clean%20background%20professional%20automotive%20photography%20side%20view&width=320&height=200&seq=veh002&orientation=landscape",
  },
  {
    name: "Outlander",
    years: "Todas las versiones",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20Outlander%20SUV%20white%20clean%20background%20professional%20automotive%20photography%20side%20view&width=320&height=200&seq=veh003&orientation=landscape",
  },
  {
    name: "ASX",
    years: "Todas las versiones",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20ASX%20crossover%20white%20clean%20background%20professional%20automotive%20photography%20side%20view&width=320&height=200&seq=veh004&orientation=landscape",
  },
  {
    name: "Nativa",
    years: "Todas las versiones",
    img: "https://readdy.ai/api/search-image?query=Mitsubishi%20Nativa%204x4%20SUV%20white%20clean%20background%20professional%20automotive%20photography%20side%20view&width=320&height=200&seq=veh005&orientation=landscape",
  },
];

export default function VehiculosSection() {
  return (
    <section id="vehiculos" className="bg-black py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-3 block">
            Compatibilidad
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4">
            Vehículos Compatibles
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-xl mx-auto">
            Trabajamos con múltiples líneas Mitsubishi. Si tu modelo no aparece aquí,{" "}
            <a href="https://wa.link/rb4jxv" target="_blank" rel="nofollow noreferrer" className="text-[#E10600] font-bold hover:underline cursor-pointer">consúltanos por WhatsApp</a>.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {vehicles.map((v) => (
            <div
              key={v.name}
              className="bg-white/5 border border-white/10 rounded-xl overflow-hidden group hover:border-[#E10600] transition-all duration-300"
            >
              <div className="h-36 overflow-hidden">
                <img
                  src={v.img}
                  alt={`Repuestos Mitsubishi ${v.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-white font-black text-base mb-1">{v.name}</h3>
                <p className="text-white/40 text-xs">{v.years}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-white/50 text-sm">
            ¿Tu modelo no está en la lista?{" "}
            <a
              href="https://wa.link/szf6pp"
              target="_blank"
              rel="nofollow noreferrer"
              className="text-[#E10600] font-bold hover:underline cursor-pointer"
            >
              Consúltanos por WhatsApp
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
